import { Link } from '@modernhealth/vital-components';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
export const MHTermsLink: FC = () => {
    const { t } = useTranslation();
    return (
        <Link css={{ fontSize: 'inherit' }}>
            <a href="https://www.modernhealth.com/terms-of-use">
                {t('shared:modern_health.terms_of_use')}
            </a>
        </Link>
    );
};
